import { useFormStore } from '@/stores/form'

export default function () {
  const formStore = useFormStore()

  const {
    preferedLanguageId,
    changePersonPhotoFlag,
    deliveryCompanyId,
    deliveryMethodId,
    mobileNumbers,
    havePoBox
  } = formStore.form.values
  const {
    showCurrentMobileNumber,
    disableDeliveryInfoSection,
    showMobileNumbersListForTawzee,
    enableNewSharedUserAddreses,
    enableNewDeliverySection,
    enableZajelDelivery,
    showBoxNumberMsg,
    showAmerDeliveryAddress,
    haveExemptions,
    disableAmerDeliveryCity,
    isInCompleteDraftFlag,
    disableAmerDeliveryEmirate,
    disableZajelDeliveryArea,
    disableZajelDeliveryCity,
    disableTawzeaDeliveryCity
  } = formStore.extraMap
  return {
    urgentServiceFlag: false,
    showCurrentMobileNumber,
    deliveryCompanyId,
    deliveryMethodId,
    haveExemptions,
    disableDeliveryInfoSection,
    preferedLanguageId,
    showMobileNumbersListForTawzee,
    enableNewDeliverySection,
    enableNewSharedUserAddreses,
    enableZajelDelivery,
    showBoxNumberMsg,
    mobileNumbers,
    showAmerDeliveryAddress,
    changePersonPhotoFlag,
    disableAmerDeliveryCity,
    isInCompleteDraftFlag,
    disableAmerDeliveryEmirate,
    disableZajelDeliveryArea,
    disableZajelDeliveryCity,
    disableTawzeaDeliveryCity,
    havePoBox
  }
}
